import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const STATUS_CONFIG = {
  researching: { label: 'Researching', color: 'text-blue-400', bg: 'bg-blue-400/12', icon: 'Search' },
  in_progress: { label: 'In Progress', color: 'text-teal-400', bg: 'bg-teal-400/12', icon: 'Loader' },
  waiting_email: { label: 'Waiting Email', color: 'text-amber-400', bg: 'bg-amber-400/12', icon: 'Mail' },
  paused: { label: 'Paused', color: 'text-orange-400', bg: 'bg-orange-400/12', icon: 'Pause' },
  success: { label: 'Success', color: 'text-emerald-400', bg: 'bg-emerald-400/12', icon: 'CheckCircle' },
  failed: { label: 'Failed', color: 'text-red-400', bg: 'bg-red-400/12', icon: 'XCircle' },
  cancelled: { label: 'Cancelled', color: 'text-gray-400', bg: 'bg-gray-400/10', icon: 'Ban' },
};

export const CHECKLIST_STATUS = {
  pending: { label: 'Pending', color: 'text-gray-400', icon: 'Circle' },
  trying: { label: 'Trying', color: 'text-blue-400', icon: 'Loader' },
  waiting: { label: 'Waiting', color: 'text-amber-400', icon: 'Clock' },
  success: { label: 'Success', color: 'text-emerald-400', icon: 'CheckCircle' },
  failed: { label: 'Failed', color: 'text-red-400', icon: 'XCircle' },
  skipped: { label: 'Skipped', color: 'text-gray-500', icon: 'SkipForward' },
};

export const TIMELINE_ICONS = {
  research: 'Search',
  knowledge: 'Brain',
  browser: 'Globe',
  captcha: 'Shield',
  email_sent: 'Send',
  email_received: 'Inbox',
  waiting: 'Clock',
  trying: 'Play',
  success: 'CheckCircle',
  failed: 'XCircle',
  error: 'AlertTriangle',
  warning: 'AlertTriangle',
  info: 'Info',
  learning: 'Lightbulb',
  cancelled: 'Ban',
  debug: 'Terminal',
  adaptive: 'Lightbulb',
};

export function formatDate(dateStr) {
  if (!dateStr) return '\u2014';
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString('de-DE', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return dateStr;
  }
}

export function formatTimeAgo(dateStr) {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    const now = new Date();
    const diffMs = now - d;
    const diffMin = Math.floor(diffMs / 60000);
    const diffH = Math.floor(diffMs / 3600000);
    const diffD = Math.floor(diffMs / 86400000);
    if (diffMin < 1) return 'just now';
    if (diffMin < 60) return `${diffMin}m ago`;
    if (diffH < 24) return `${diffH}h ago`;
    return `${diffD}d ago`;
  } catch {
    return '';
  }
}

export function formatTime(dateStr) {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    return d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  } catch {
    return dateStr;
  }
}
